export const styles = {
containerMain: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "white",
    alignItems: {xs: "center",sm:"center"},
    justifyContent: {xs: "center",sm:"center"}, // Center the form vertically
    height: "100%", // Adjust to make the form taller if needed
    width: { xs: "100%", sm: "90%" },
    margin: "auto",
    padding: {xs: "5px", sm: "20px"},
    marginTop: {xs: "20px", sm: "70px"}
},
container: {
  display: "flex",
  flexDirection: "column",
  backgroundColor: "white",
  alignItems: {xs: "center",sm:"center"},
  justifyContent: {xs: "center",sm:"center"}, // Center the form vertically
  height: "100%", // Adjust to make the form taller if needed
  width: { xs: "100%", sm: "90%" },
  margin: "auto",
  padding: {xs: "5px", sm: "20px"},
  marginTop: "20px"
},
firstTabSubModel: {
  textTransform: 'none',
  fontSize: "16px",
  color: "black",
  fontWeight: "500",
  marginLeft: "20px",
  justifyContent: "flex-start",
  textAlign: "left",
  alignItems: "flex-start",
},
heading: {
  fontWeight: "500",
  fontSize: "24px",
  lineHeight: "36px",
  marginBottom: "13px", // Added margin bottom to separate title from subtitle
},
subHeading: {
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "21px",
  color: "#8295B3",
  marginBottom: "55px", // Add some space between subtitle and form
},
fieldContainer: {
  width: {xs: "100%", sm:"500px"},
    marginBottom: "10px",
    display: "flex",
    flexDirection: {xs: "column",sm:"row"},

    alignItems: "flex-start",
},
label: {
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "28px",
  color: "#232323",
  marginBottom: {xs: "10px",sm:"40px"}, // Space between label and input
  width: "200px",
},
textField: {
  width: {xs: "100%", sm:"300px"}, 
    height: "40px",
    border: "1px solid #C4C4C4",
    borderRadius: "5px",
    textAlign: "left",
    "& .MuiOutlinedInput-root": {
        height: "40px",
        padding: "0 14px",
    },
    "& .MuiInputBase-input": {
        padding: "12px 14px",
        textAlign: "left",
    },
},
appButton: {
  backgroundColor: "#01A768",
  // display: "flex",
  // justifyContent: "flex-end",
  height: "36px",
  width: "91px",
  color: "white",
  margin: "auto",
  marginRight: "0px",
  fontSize: "14px",
},
appButtonBox: {
  display: "flex",
  alignItems: "flex-end",
  justifyItems: "flex-end",
  marginTop: "20px",
  width: "100%"
},
link: {
  marginLeft: 2,
  marginTop: 1,
  pointer: "cursor",
  fontWeight: "500",
  fontSize: "14px",
  textDecoration: "none",
  color: "#635C5C",
},
error: {
  marginLeft: 2,
  marginTop: 1,
  pointer: "cursor",
  fontWeight: "400",
  fontSize: "10px",
  textDecoration: "none",
  color: "red",
},
currentPasswordBox: {
  display: "flex",
  alignItems: "flex-end",
  flexDirection: "column",
  width: { xs: "100%",
  sm: "300px",
  },
},
}

